<template lang="pug">
  div(:class="'content-slider '+'container-'+this._uid")
    div(class="slider-nav")
      router-link(v-for="(d, i) in this.sliders[0].slides" class="item" :to="{ path: d.slug ? '/' + d.slug : d.url, params: {}}" :key="'slider-nav-item-' + i")
        h4.title
          vue-markdown(:source='d.title')
        vue-markdown(:source='d.desc' class="desc")
      router-link.slider-link.button.special.item(:to="{ path: this.sliders[0].link || null, params:{}}" v-show="this.sliders[0].link")
        h4.title {{ "Browse all courses" }}
          //- vue-markdown(:source='this.sliders[0].link')
</template>

<script>
import Vue from 'vue'
import sectionBase from '@/components/sections/sectionBase.js'

// component instance
var contentSlider = Vue.component('content-slider', {
  name: 'contentSlider',
  mixins: [sectionBase],
  props: [],
  data: function () {
    return {
    }
  },
  watch: {
  },
  methods: {
    // TODO: create a timed loop to put an active class on the items
  },
  computed: {
    sliders () {
      let slideData = this.payload.fields.content
      let sliders = []

      // TODO: will parse all but only first one is used ATM
      slideData.forEach((d, i) => {
        let slider = {name: d.fields.title, link: d.fields.link, slides: []}

        if (d.fields.itemReferences.length > 0) {
          d.fields.itemReferences.forEach((s, n) => {
            // let b = s.fields.description && s.fields.description.substr(0, 40)
            // b = b && b.substr(0, Math.min(b.length, b.lastIndexOf(' ')))
            let b = s.fields.description

            Vue.set(slider.slides, n, {title: s.fields.title, desc: s.fields.description && `${b}`, url: `/${s.fields.type.toLowerCase()}/${s.sys.id}`})
          })
          Vue.set(sliders, i, slider)
        } else {
          d.fields.itemTitles.forEach((s, n) => {
            Vue.set(slider.slides, n, {title: s, desc: d.fields.itemDescriptions[n]})
          })
          Vue.set(sliders, i, slider)
        }
      })

      return sliders
    }
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default contentSlider
</script>

<style scoped lang="scss">
.content-slider{

  .slide{

  }

  .slider-nav{
    display: flex;

    .item{
      flex: 1;
      background: get-color(primary);

      color: $white;
      padding: 3rem 3.5rem 0;

      min-height: 150px;

      margin-top: 0px;
      transition: margin .3s ease-in-out;

      &.active, &:hover{
        background: get-color(primary-min1);
        margin-top: -30px;
      }

      .title{
        font-size: header-size('medium', h4);
        font-weight: 400;
        color: $white;
        line-height: 1.2;
        letter-spacing: .1em;
        text-transform: uppercase;
        border-bottom: 1px solid $white;
        width: 80%;

        min-height: 43px;
        margin-bottom: -2rem;

        margin-top: 2rem;

        transition: margin .4s ease-out;
      }
      .desc{
        display: block;
        padding-bottom: 1rem;
        transition: max-height .4s ease-out, opacity .4s ease-out;
        // max-height: 0px;
        opacity: 0;

        color: get-color(primary-plus1)
      }
      &:hover .desc{
        // max-height: 100px;
        opacity: 1;
      }
      &:hover .title{
        margin-top: 0;
        margin-bottom: 2rem;
      }

    }
  }

  .slider-link.item{
    flex: 1;

    padding-top: 55px;
    margin-top: -55px;

    background-color: get-color(secondary-plus1);

    .title{
      color: get-color(primary);
      min-height: 63px;
    }
    &:after{
      top: calc(50% - 23px);
      right: 23px;

      width: 45px;
      height: 45px;
    }
    &:hover{
      background: get-color(secondary);
      // color:
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sections/contentSlider.vue